// Austrian-compliant Impressum content for Caireen Verein
// Legal basis:
//   § 5 ECG (E-Commerce-Gesetz)
//   § 25 MedienG (Mediengesetz – Offenlegungspflicht)
//   Vereinsgesetz 2002 (VerG)
// The DE version is authoritative for legal purposes.

export const impressumContent = {
    hu: {
        title: "Impresszum",
        subtitle: "Jogi információk és a Mediengesetz 25. §-a szerinti tájékoztatás",
        note: "Az osztrák jog értelmében a német nyelvű változat a mérvadó.",
        sections: [
            {
                heading: "A médium tulajdonosa és kiadója",
                body:
                    "Caireen Verein (Caireen e.V.)\nSzékhely: Innerteuchen 26, 9543 Arriach, Ausztria\nJogforma: Az osztrák Egyesületi Törvény 2002 (Vereinsgesetz 2002 – VerG) szerint bejegyzett közhasznú egyesület",
            },
            {
                heading: "Nyilvántartási adatok",
                body:
                    "ZVR-szám (Egyesületi nyilvántartási szám): 1121813363\nEgyesületi felügyelet: Bezirkshauptmannschaft Villach-Land\nBejegyzés helye: Ausztria (Karintia tartomány)",
            },
            {
                heading: "Kapcsolat",
                body:
                    "E-mail: office@caireen.at\nHonlap: https://caireen.at",
            },
            {
                heading: "Képviseletre jogosult szervek (Elnökség)",
                body:
                    "Az egyesületet a Vorstand (elnökség) képviseli a Statútum rendelkezései szerint.\nA mindenkori elnökség tagjainak listája az egyesületnél kérésre elérhető.",
            },
            {
                heading: "Az egyesület célja",
                body:
                    "Közhasznú egyesület az egészség, oktatás, kutatás, társadalmi integráció, művészet és kultúra, valamint a nemzetközi együttműködés előmozdítására. Az egyesület kizárólag és közvetlenül közhasznú célokat követ az osztrák szövetségi adótörvény (BAO) 34. és következő §-ai értelmében. Az egyesület nem törekszik gazdasági haszonszerzésre.",
            },
            {
                heading: "A médium alapvető iránya (MedienG § 25)",
                body:
                    "Tájékoztatás a Caireen Verein tevékenységéről, projektjeiről és céljairól, különös tekintettel az egészségügyi innováció, oktatás, kutatás, társadalmi integráció, művészet és kultúra, valamint a nemzetközi együttműködés területeire.",
            },
            {
                heading: "Felelősségi kizáró nyilatkozat",
                body:
                    "A gondos ellenőrzés ellenére sem vállalunk felelősséget a külső linkek tartalmáért. A linkelt oldalak tartalmáért kizárólag azok üzemeltetői felelnek.",
            },
            {
                heading: "Szerzői jog",
                body:
                    "A honlap valamennyi tartalma (szövegek, grafikák, képek, logók) szerzői jogi védelem alatt áll, és a Caireen Verein előzetes írásbeli hozzájárulása nélkül nem használható fel.",
            },
            {
                heading: "Online vitarendezés",
                body:
                    "Az Európai Bizottság online vitarendezési platformot (OS) biztosít: https://ec.europa.eu/consumers/odr\nAz egyesület nem köteles fogyasztói választottbírósági eljárásban részt venni, és nem is szándékozik ezt tenni.",
            },
            {
                heading: "Adatvédelem",
                body:
                    "Az Ön személyes adatait az EU Általános Adatvédelmi Rendelete (GDPR) és az osztrák adatvédelmi törvény (DSG) rendelkezéseinek megfelelően kezeljük. Adatvédelmi kérdésekben az office@caireen.at címen léphet velünk kapcsolatba.",
            },
        ],
    },

    de: {
        title: "Impressum",
        subtitle: "Angaben gemäß § 5 ECG und Offenlegung nach § 25 Mediengesetz",
        note: "Diese deutsche Fassung ist für rechtliche Zwecke maßgeblich.",
        sections: [
            {
                heading: "Medieninhaber und Herausgeber",
                body:
                    "Caireen Verein (Caireen e.V.)\nVereinssitz: Innerteuchen 26, 9543 Arriach, Österreich\nRechtsform: Gemeinnütziger Verein nach dem österreichischen Vereinsgesetz 2002 (VerG)",
            },
            {
                heading: "Registerdaten",
                body:
                    "ZVR-Zahl: 1121813363\nVereinsbehörde: Bezirkshauptmannschaft Villach-Land\nSitz: Österreich (Kärnten)",
            },
            {
                heading: "Kontakt",
                body:
                    "E-Mail: office@caireen.at\nWebsite: https://caireen.at",
            },
            {
                heading: "Vertretungsberechtigte Organe (Vorstand)",
                body:
                    "Der Verein wird durch den Vorstand nach Maßgabe der Vereinsstatuten vertreten.\nEine Liste der aktuellen Vorstandsmitglieder ist auf Anfrage beim Verein erhältlich.",
            },
            {
                heading: "Vereinszweck",
                body:
                    "Gemeinnütziger Verein zur Förderung von Gesundheit, Bildung, Forschung, sozialer Integration, Kunst und Kultur sowie internationaler Zusammenarbeit. Der Verein verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne der §§ 34 ff der österreichischen Bundesabgabenordnung (BAO) und ist nicht auf Gewinn ausgerichtet.",
            },
            {
                heading: "Grundlegende Richtung des Mediums (§ 25 MedienG)",
                body:
                    "Information über die Tätigkeit, Projekte und Anliegen des Caireen Verein, insbesondere in den Bereichen Gesundheitsinnovation, Bildung, Forschung, soziale Integration, Kunst und Kultur sowie internationale Kooperation.",
            },
            {
                heading: "Haftungsausschluss",
                body:
                    "Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.",
            },
            {
                heading: "Urheberrecht",
                body:
                    "Alle Inhalte dieser Website (Texte, Grafiken, Bilder, Logos) sind urheberrechtlich geschützt und dürfen ohne vorherige schriftliche Zustimmung des Caireen Verein nicht weiterverwendet werden.",
            },
            {
                heading: "Online-Streitbeilegung",
                body:
                    "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr\nDer Verein ist nicht bereit oder verpflichtet, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
            },
            {
                heading: "Datenschutz",
                body:
                    "Personenbezogene Daten werden im Einklang mit der EU-Datenschutz-Grundverordnung (DSGVO) und dem österreichischen Datenschutzgesetz (DSG) verarbeitet. Bei Fragen zum Datenschutz erreichen Sie uns unter office@caireen.at.",
            },
        ],
    },

    en: {
        title: "Legal notice (Impressum)",
        subtitle: "Information pursuant to § 5 ECG and disclosure under § 25 of the Austrian Media Act",
        note: "The German version prevails for legal purposes.",
        sections: [
            {
                heading: "Media owner and publisher",
                body:
                    "Caireen Verein (Caireen e.V.)\nRegistered office: Innerteuchen 26, 9543 Arriach, Austria\nLegal form: Non-profit association registered under the Austrian Associations Act 2002 (Vereinsgesetz 2002 – VerG)",
            },
            {
                heading: "Register data",
                body:
                    "ZVR number (Association register): 1121813363\nSupervisory authority: Bezirkshauptmannschaft Villach-Land\nPlace of registration: Austria (Carinthia)",
            },
            {
                heading: "Contact",
                body:
                    "Email: office@caireen.at\nWebsite: https://caireen.at",
            },
            {
                heading: "Authorised representatives (Board)",
                body:
                    "The association is represented by the Board (Vorstand) in accordance with the statutes.\nA current list of Board members is available on request from the association.",
            },
            {
                heading: "Purpose of the association",
                body:
                    "Non-profit association promoting health, education, research, social integration, art and culture, and international cooperation. The association exclusively and directly pursues charitable purposes within the meaning of §§ 34 ff of the Austrian Federal Fiscal Code (BAO) and is not oriented towards profit.",
            },
            {
                heading: "Basic direction of the medium (§ 25 MedienG)",
                body:
                    "Information about the activities, projects and concerns of Caireen Verein, in particular in the fields of health innovation, education, research, social integration, art and culture, and international cooperation.",
            },
            {
                heading: "Disclaimer",
                body:
                    "Despite careful review, we assume no liability for the contents of external links. Only the operators of the linked pages are responsible for their content.",
            },
            {
                heading: "Copyright",
                body:
                    "All content on this website (texts, graphics, images, logos) is protected by copyright and may not be re-used without the prior written consent of Caireen Verein.",
            },
            {
                heading: "Online dispute resolution",
                body:
                    "The European Commission provides an online dispute resolution (ODR) platform: https://ec.europa.eu/consumers/odr\nThe association is neither willing nor obliged to participate in dispute-resolution proceedings before a consumer arbitration board.",
            },
            {
                heading: "Data protection",
                body:
                    "Personal data are processed in accordance with the EU General Data Protection Regulation (GDPR) and the Austrian Data Protection Act (DSG). For data-protection queries please contact office@caireen.at.",
            },
        ],
    },
};

export default impressumContent;
